import React from 'react';
import { Mouvement } from '@mairistem/comptabilite';
import TravauxEnRegieComponent from '../../../components/Mouvement/Panel/TravauxEnRegieComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import LignePanel from './LignePanel';

class TravauxEnRegiePanel extends LignePanel {
  constructor(isMandatory = false) {
    super(isMandatory);
    this.code = CODE_PANEL.TRAVAUX_EN_REGIE;
    this.icon = { name: 'child' };
    this.defaultSize = 6;
  }

  getLibelle = () => 'Travaux en régie';

  isEmpty = (data: Mouvement) => !data?.lignes?.find((ligne) => ligne?.cocheTravauxRegie);

  getComponent = function getComponent(
    data: any,
    onChange: any,
    handlePin: any,
    sens: string,
    ...rest: any
  ): React.ReactElement {
    return (
      <TravauxEnRegieComponent
        data={data}
        handlePin={handlePin}
        onChange={onChange}
        panel={this}
        {...rest}
      />
    );
  };
}

export default TravauxEnRegiePanel;
